import { StyleSheet } from 'react-native-web';

// separate style sheet from the rest of discover to port to shared library
// once we figure out react native slider loading issue
const styles = StyleSheet.create({
  container: {
    marginTop: 10,
    marginHorizontal: 15,
  },
  title: {
    fontSize: 18,
    fontWeight: 700,
    marginBottom: 10,
    letterSpacing: 0.5,
  },
  timesContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 10,
  },
});

export default styles;
